import React, { useState, useEffect } from "react";
import { LanguageContext } from "./LanguageContext";
import { translations } from "../api/translations";

export const LanguageProvider = ({ children }) => {
  const defaultLanguage = navigator.language.startsWith("fr")
    ? "fr"
    : navigator.language.startsWith("de")
    ? "de"
    : navigator.language.startsWith("es")
    ? "es"
    : "en";
  const safeDefaultLanguage = translations[defaultLanguage]
    ? defaultLanguage
    : "en";
  const [language, setLanguageState] = useState(safeDefaultLanguage);

  const setLanguage = (newLanguage) => {
    setLanguageState(newLanguage);
  };

  useEffect(() => {}, [language]); // Cette dépendance assure que le code s'exécute chaque fois que `language` change.

  const translate = (key) =>
    (translations[language] || translations.en || {})[key] || key;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translate }}>
      {children}
    </LanguageContext.Provider>
  );
};
